import { createAction } from '@reduxjs/toolkit';

export const fetchCurrentUserStart = createAction<{ spotId?: string; networkId?: string }>(
  'ACCOUNT/CURRENT_USER_START'
);

export const fetchCurrentUserFailure = createAction('ACCOUNT/CURRENT_USER_FAILURE');

export const forgotPasswordStart = createAction('ACCOUNT/FORGOT_PASSWORD_START');
export const forgotPasswordSuccess = createAction('ACCOUNT/FORGOT_PASSWORD_SUCCESS');
export const forgotPasswordFailure = createAction('ACCOUNT/FORGOT_PASSWORD_FAILURE');

export const resetPasswordStart = createAction('ACCOUNT/RESET_PASSWORD_START');
export const resetPasswordSuccess = createAction('ACCOUNT/RESET_PASSWORD_SUCCESS');
export const resetPasswordFailure = createAction('ACCOUNT/RESET_PASSWORD_FAILURE');

